// extracted by mini-css-extract-plugin
export default {"user-status-fixed":"App_user-status-fixed__H+J6N","main-content":"App_main-content__cO4Ec"};